import React from "react";
import { Row, Col } from "react-bootstrap";

//  Assets
import Quote from "../images/quote.svg";

// Styles
import "./TestimonialBox.scss";

const TestimonialBox = ({ testimonial, onDragStart, role }) => {
    return (
        <div className="testemunho mx-3" onDragStart={onDragStart} role={role}>
            <Row>
                <Col sm={12} md={4}>
                    <div className="text-center">
                        <img
                            src={testimonial.profilePic}
                            alt={testimonial.name + "profile image"}
                            className="testemunho-imagem"
                        />
                    </div>
                </Col>
                <Col sm={12} md={8}>
                    <div className="testemunho-texto ps-3">
                        <p>{testimonial.text}</p>
                        <p className="name">
                            <span>{testimonial.name}</span>
                            , {testimonial.title}
                        </p>
                        <p className="mb-0">
                            <img
                                src={Quote}
                                alt="quote"
                                className="quote float-end"
                            />
                        </p>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default TestimonialBox;
